module.exports = __webpack_public_path__ + "img/KP.48c077d5.svg";